module.exports = __webpack_public_path__ + "static/media/greater-than.adf8f3cd.svg";